import { createContext, useEffect, useState } from 'react';

import { onAuthStateChanged } from 'firebase/auth';

import { getDoc, doc } from 'firebase/firestore';

import { db, auth } from '../firebase_config';

export const useUserData = () => {
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState('');
  const [cart, setCart] = useState([]);
  const [count, setCount] = useState(0);
  const [sum, setSum] = useState(0);
  const [wishList, setWishList] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    onAuthStateChanged(auth, async (currentUser) => {
      await setUser(currentUser);

      if (currentUser) {
        const userRef = doc(db, 'users', currentUser.uid);

        getDoc(userRef)
          .then((doc) => {
            setUserName(doc.data().name);
            setCount(doc.data().count);
            setSum(doc.data().sum);
            setCart(doc.data().cart);
            setWishList(doc.data().wishList);
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    });
  }, []);

  return {
    user,
    userName,
    setUserName,
    cart,
    setCart,
    count,
    setCount,
    sum,
    setSum,
    wishList,
    setWishList,
    search,
    setSearch,
  };
};

export const UserContext = createContext({});
